import Schrank from "./Schrank";
import SchwebetuerFluegel from "./SchwebetuerFluegel";
import Commons from "oc-commons/Commons";
import type {HasLocalCoordinates} from "./HasLocalCoordinates";
import SchwebetuerO3 from "../object3d/Schwebetuer";
import Brett from "./Brett";
import Interieur from "./Interieur";


export default class Schwebetuer implements HasLocalCoordinates {
    // DO NOT CHANGE
    className = "Schwebetuer";


    // persistent (UserLayer) ------------------------------------------

    product: ?Object;
    schwebetuerFluegel: ?SchwebetuerFluegel[] = [];

    // transient (CompiledLayer) ---------------------------------------

    schrank: Schrank;
    object3d: ?THREE.Object3D;
    schienen: Brett[] = [];
    isClosed: boolean = true;

    constructor(schrank) {
        this.schrank = schrank;
        this.product = APP.findProduct('Schwebetuer');
    }

    get parent() {
        return this.schrank;
    }

    get child3dContainer() {
        return this.object3d;
    }

    schrankToLocal(v: THREE.Vector3) {
        return this.schrank.schrankToLocal(v);
    }

    localToSchrank(v: THREE.Vector3) {
        return this.schrank.localToSchrank(v);
    }

    getFrontOffset() {
        return this.schrank.options.getFloat('schiebetuer_vorsprung', 8);
    }

    fromJSON(json) {
        if (json) {
            this.schwebetuerFluegel = Commons.mapreuse(json.fluegel, this.schwebetuerFluegel, e => new SchwebetuerFluegel(this), (d, s) => d.fromJSON(s));
        }
        return this;
    }

    toJSON() {
        return {
            className: this.className,
            fluegel: this.schwebetuerFluegel.map(f => f.toJSON())
        };
    }

    copy(schwebetuer,createInterceptor) {
        this.product = schwebetuer.product;
        this.schwebetuerFluegel = Commons.mapreuse(schwebetuer.schwebetuerFluegel,this.schwebetuerFluegel,(s)=>new SchwebetuerFluegel(this),(d,s)=>d.copy(s,createInterceptor));
        return this;
    }

    compile() {
        APP.model.lazyCreateObject3d(this, () => {
            const o3 = new SchwebetuerO3(this);
            this.schrank.child3dContainer.add(o3);
            return o3;
        });

        const schienen = APP.model.lazyPool(this, 'schienen', () => {
            const brett = new Brett(this, 'Schwebetuerschienen', 'xz');
            brett.fixedMaterialKey = 'alu';
            return brett;
        });

        const schiene = () => {
            const schiene = schienen.next();
            schiene.box.min.copy(this.schrank.corpusBox.min);
            schiene.box.max.copy(this.schrank.corpusBox.max);
            return schiene;
        };

        const brettstaerke = this.schrank.options.getFloat('brett_staerke');
        const schiebetuer_leiste_oben_hoehe = this.schrank.options.getFloat('schiebetuer_leiste_oben_hoehe', 4);
        const schiebetuer_leiste_unten_hoehe = this.schrank.options.getFloat('schiebetuer_leiste_unten_hoehe', 1);
        const schiebetuer_leiste_oben_tiefe = this.schrank.options.getFloat('schiebetuer_leiste_oben_tiefe', 0.8);
        const schiebetuer_leiste_unten_tiefe = this.schrank.options.getFloat('schiebetuer_leiste_unten_tiefe', 2);

        const schiebetuer_stopleiste_vorsprung_min = this.schrank.options.getMinValue('schiebetuer_stopleiste_vorsprung', 1.5);
        const schiebetuer_stopleiste_vorsprung_max = this.schrank.options.getMaxValue('schiebetuer_stopleiste_vorsprung', 4.5);
        const schiebetuer_stopleiste_breite = this.schrank.options.getFloat('schiebetuer_stopleiste_breite', 0.5);

        const schieneOben = schiene();
        schieneOben.box.min.z = this.schrank.corpusBox.max.z;
        schieneOben.box.min.x += brettstaerke;//schiebetuer_stopleiste_breite;
        schieneOben.box.max.x -= brettstaerke;//schiebetuer_stopleiste_breite;
        schieneOben.box.max.z += schiebetuer_leiste_oben_tiefe;
        schieneOben.box.min.y = schieneOben.box.max.y - schiebetuer_leiste_oben_hoehe;

        const schieneUnten = schiene();
        schieneUnten.box.min.z = this.schrank.corpusBox.max.z;
        schieneUnten.box.min.x += brettstaerke;//schiebetuer_stopleiste_breite;
        schieneUnten.box.max.x -= brettstaerke;//schiebetuer_stopleiste_breite;
        schieneUnten.box.max.z += schiebetuer_leiste_unten_tiefe;
        schieneUnten.box.max.y = this.schrank.elementsBox.min.y;
        schieneUnten.box.min.y = schieneUnten.box.max.y - schiebetuer_leiste_unten_hoehe;

/*        const stopLeisteLinks = schiene();
        stopLeisteLinks.box.min.y = this.schrank.elementsBox.min.y - brettstaerke;
        stopLeisteLinks.box.min.z = this.schrank.corpusBox.max.z;
        stopLeisteLinks.box.max.z += schiebetuer_stopleiste_vorsprung_min;
        stopLeisteLinks.box.max.x = stopLeisteLinks.box.min.x + schiebetuer_stopleiste_breite;

        const stopLeisteRechts = schiene();
        stopLeisteRechts.box.min.y = this.schrank.elementsBox.min.y - brettstaerke;
        stopLeisteRechts.box.min.z = this.schrank.corpusBox.max.z;
        stopLeisteRechts.box.max.z += this.schrank.elements.length % 2 == 0 ? schiebetuer_stopleiste_vorsprung_max : schiebetuer_stopleiste_vorsprung_min;
        stopLeisteRechts.box.min.x = stopLeisteRechts.box.max.x - schiebetuer_stopleiste_breite;*/

        schienen.cleanup();

        this.schienen.forEach(x => {
            x.boxToVertices();
            x.compile();
        });

        this.schwebetuerFluegel = Commons.mapreuse(this.schrank.elements, this.schwebetuerFluegel, e=>new SchwebetuerFluegel(this), (d,s) => d);
        this.schwebetuerFluegel.forEach(f => f.compile());

    }

    showClosed(close, time) {
        if (close === this.isClosed) return;
        this.isClosed = close;
        this.object3d.animate({
            opacity: close ? 1 : 0,
            duration: time,
            onStart: () => {
                this.object3d.visible = !close;
            },
            onComplete: () => {
                this.object3d.visible = close;
            },
        });
    }

    iterate(iterator) {
        iterator(this);
        this.schwebetuerFluegel.forEach(iterator);
    }

}

